import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";


export class AddUser extends EntityDto implements IEntityDto {
    UserId: number;
    UserName: string;
    PasswordHash: string;
    CompanyId: number;
    Entity_Name: string;
    Vendor_Id: number;
    Vendor_Name: string;
    PhoneNumber: string;
    Email: string;
    EmpRefId: number;
    Emp_Name: string;
    UserRoles: Array<UserRole>;
    User_Type_Name: string;
    UserTypeId: number;
    Requested_Emp_Ref_Id: number;
    User_Type_Id: number;
    Entity_Id: number;
    approvalModeList: UserRole[];
    Role_Id: any;
    // Id: number;
    Location_Id:string;
    LocationName:string;
    constructor() {
        super();
        this.UserId = 0;
        this.UserName = "";
        this.PasswordHash = "";
        this.CompanyId = 0;
        this.Entity_Name = "";
        this.Vendor_Id = 0;
        this.Vendor_Name = "";
        this.PhoneNumber = "";
        this.Email = "";
        this.EmpRefId = 0;
        this.Emp_Name = "";
        this.UserRoles = [];
        this.User_Type_Name = ""
        this.UserTypeId = 0;
        this.Requested_Emp_Ref_Id = 0;
        this.User_Type_Id = 0;
        this.Entity_Id = 0;
        this.approvalModeList = [];
        this.Location_Id="";
        this.LocationName="";
        // this.Id = 0;
        this.EntityMetaData = [
            { FieldName: 'UserName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'User Name is required' },
            { FieldName: 'EmpRefId', FieldType: FieldType.Key, IsMandatory: true, ValidationMessage: 'Name is required' },
            { FieldName: 'Entity_Id', FieldType: FieldType.Key, IsMandatory: true, ValidationMessage: 'Entity Name is required' },
            { FieldName: 'Email', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email Id is required' },
            { FieldName: 'PasswordHash', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Password is required' },
            { FieldName: 'PhoneNumber', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Phone is required' },
            { FieldName: 'User_Type_Name', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'User Type is required' },
            
        ];
    }
}

export class UserRole extends EntityDto implements IEntityDto {
    UserRoleId: number;
    User_Id: number;
    Role_Name: string;
    Role_Id: number;
    Emp_Name: any;
    Text_Value: string;
    Value_Id: number;
    // selectedAppType: {};
    // selectemp: {};
    // selectvendor: {};
    Vendor_Id: any;
    Vendor_Name: any;
    constructor() {
        super();
        this.UserRoleId = 0;
        this.Role_Name = "";
        this.Role_Id = 0;
        this.User_Id = 0;
        this.Text_Value = "";
        this.Value_Id = 0;
        // this.selectedAppType = [];
        // this.selectemp = [];
        // this.selectvendor = [];
    }
}

export class UserType extends EntityDto implements IEntityDto {

    UserTypeId: number;
    User_Type_Name: string;

    constructor() {
        super();
        this.User_Type_Name = "";
        this.UserTypeId = 0;
    }
}

export class Emp extends EntityDto implements IEntityDto {
    Emp_Ref_Id: number;
    ContactNo: string;
    EmailId: string;

    constructor() {
        super();
        this.Emp_Ref_Id = 0;
        this.ContactNo = "";
        this.EmailId = "";
    }
}
